<div
  class="results-table--grid--row--content {{ numOfLogos > 0 ? 'has-photo-grid-' + numOfLogos : '' }}"
  [ngClass]="{
    'has-tertiary-content': showTertiary,
    'results-table--grid--team-name-only': !firstName && teamName,
  }"
>
  @if (numOfLogos > 0) {
    <div class="results-table--grid--photo--container">
      @if (displayProfilePic) {
        @if (profilePicSrc) {
          <img class="results-table--grid--athlete-picture" width="29" height="29" [ngSrc]="profilePicSrc" />
        } @else {
          <div class="results-table--grid--athlete-picture avatar-initial">{{ composeInitials() }}</div>
        }
      }

      @if (this.forceGap && !displayProfilePic && !(displayLogo || (displayLogo && teamName && !firstName))) {
        <div class="gap">&nbsp;</div>
      }

      <!-- Display logo only if there is a profile picture or only a teamName -->
      @if (displayLogo || (displayLogo && teamName && !firstName)) {
        <img
          [ngClass]="{
            'results-table--grid--team-logo-only': !displayProfilePic,
            'results-table--grid--team-logo': displayProfilePic,
            'team-logo-rounded': teamLogoSrc && teamLogoSrc.indexOf('static.') === -1,
          }"
          [src]="teamLogoSrc"
        />
      }
    </div>
  }

  <div class="results-table--grid--row--main-content">
    <div class="results-table--grid--primary">
      <div class="results-table--grid--title results-table--ell-overflow">
        @if (!firstName && teamName && teamRankNumber) {
          <span class="team-ranking">{{ teamRankNumber }}</span>
        }
        {{ (firstName ? firstName : teamName ? teamName : '') + (lastName ? ' ' + lastName : '') }}
      </div>
      @if (teamName && firstName) {
        <div class="results-table--grid--subtitle results-table--grid--team">
          <!-- Only display logo if we know the primary text isn't the teamName -->
          @if (numOfLogos === 2 && displayLogo && teamName && firstName) {
            <img
              [ngClass]="{
                'hide-if-narrow': displayProfilePic,
                'team-logo-rounded': teamLogoSrc && teamLogoSrc.indexOf('static.') === -1,
              }"
              width="29"
              height="29"
              [src]="teamLogoSrc"
            />
          } @else if (forceGap && teamName && firstName) {}
          <div class="results-table--grid--team-name results-table--ell-overflow">
            @if (teamRankNumber) {
              <span class="team-ranking">{{ teamRankNumber }}</span>
            }
            {{ teamName }}
          </div>
        </div>
      } @else if (putTertiaryInTeamPlace) {
        <div class="results-table--grid--subtitle results-table--grid--team hide-if-wide">
          <app-tertiary-stats
            [result]="tertiaryResult"
            [showSeed]="showSeed"
            [showHeat]="showHeat"
            [showNotes]="showNotes"
            [showSecondaryStats]="showSecondaryStats"
            [showLapsToGo]="showLapsToGo"
            [showAthleteStats]="showAthleteStats"
            [showRecords]="showRecords"
            [showCombinedPoints]="showCombinedPoints"
            [showGap]="showGap"
            [showWind]="showWind"
            [primaryEventGroup]="primaryEventGroup"
          ></app-tertiary-stats>
        </div>
      }
    </div>
    <div class="results-table--grid--secondary">
      @if (showSecondary) {
        @if (secondaryValue) {
          <div class="results-table--grid--title">{{ secondaryValue }}</div>
        }
        @if (secondaryResult || secondaryRawSubTitleValue !== undefined) {
          <div class="results-table--grid--subtitle">
            @if (secondaryRawSubTitleValue) {
              {{ secondaryRawSubTitleValue }}
            } @else if (secondaryResult) {
              <app-secondary-stats [result]="secondaryResult"></app-secondary-stats>
            }
          </div>
        } @else if (verticalJumps !== undefined) {
          <div class="data-card--stats--vertical-jumps">
            @for (jumpIdx of [0, 1, 2]; track jumpIdx) {
              <div class="split-cell--vert-jump split-cell--vert-jump-{{ verticalJumps[jumpIdx] }}">
                @if (verticalJumps[jumpIdx]) {
                  <span>
                    {{ verticalJumps[jumpIdx] }}
                  </span>
                } @else {
                  <span> &nbsp; </span>
                }
              </div>
            }
          </div>
        }
      } @else {
        &nbsp;
      }
    </div>
  </div>
  @if (showTertiary) {
    <div class="results-table--grid--row--tertiary-content" [ngClass]="{ 'hide-if-narrow': putTertiaryInTeamPlace }">
      <app-tertiary-stats
        [result]="tertiaryResult"
        [showSeed]="showSeed"
        [showHeat]="showHeat"
        [showNotes]="showNotes"
        [showSecondaryStats]="showSecondaryStats"
        [showLapsToGo]="showLapsToGo"
        [showAthleteStats]="showAthleteStats"
        [showRecords]="showRecords"
        [showCombinedPoints]="showCombinedPoints"
        [showGap]="showGap"
        [showWind]="showWind"
        [primaryEventGroup]="primaryEventGroup"
      ></app-tertiary-stats>
    </div>
  }
</div>
